import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=68a3b90b&"
import script from "./commentList.vue?vue&type=script&lang=js&"
export * from "./commentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports